(() => {
  const PREFERRED_STAND = 'Jeg ønsker ikke stativ';

  function getSelectedOptions() {
    // Craft uses radio buttons or selects depending on settings.
    // We read by option name if possible; fallback to option index.
    const container = document.querySelector('variant-selects, variant-radios');
    if (!container) return null;

    // Try to read selects (variant-selects)
    const selects = container.querySelectorAll('select');
    if (selects && selects.length) {
      return Array.from(selects).map(s => s.value);
    }

    // Try to read radios (variant-radios)
    const fieldsets = container.querySelectorAll('fieldset');
    if (fieldsets && fieldsets.length) {
      return Array.from(fieldsets).map(fs => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    return null;
  }

  function setOptionValue(optionIndex1Based, value) {
    const container = document.querySelector('variant-selects, variant-radios');
    if (!container) return false;

    // selects
    const selects = container.querySelectorAll('select');
    if (selects && selects.length >= optionIndex1Based) {
      const sel = selects[optionIndex1Based - 1];
      if (!sel) return false;
      if (sel.value === value) return true;
      const opt = Array.from(sel.options).find(o => o.value === value);
      if (!opt) return false;
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    // radios
    const fieldsets = container.querySelectorAll('fieldset');
    if (fieldsets && fieldsets.length >= optionIndex1Based) {
      const fs = fieldsets[optionIndex1Based - 1];
      if (!fs) return false;
      const input = fs.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
      if (!input) return false;
      if (input.checked) return true;
      input.click(); // triggers theme change handlers
      return true;
    }

    return false;
  }

  function findVariantByOptions(variants, optionsArray) {
    return variants.find(v => {
      if (!v || !v.options) return false;
      return v.options.every((opt, i) => opt === optionsArray[i]);
    });
  }

  function findFirstAvailableVariantForSize(variants, sizeValue) {
    return variants.find(v => v.available && v.options && v.options[1] === sizeValue);
  }

  function ensureValidStativSelection() {
    const productForm = document.querySelector('product-form form');
    const productJsonEl = document.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');
    if (!productForm || !productJsonEl) return;

    let variants;
    try {
      variants = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants)) return;

    const selected = getSelectedOptions();
    if (!selected || selected.length < 3) return;

    const [color, size, stand] = selected;

    // If current combination exists and is available, do nothing
    const current = findVariantByOptions(variants, [color, size, stand]);
    if (current && current.available) return;

    // Try preferred stand for the selected color + size
    const preferred = findVariantByOptions(variants, [color, size, PREFERRED_STAND]);
    if (preferred && preferred.available) {
      setOptionValue(3, PREFERRED_STAND); // Option 3 = Stativ
      return;
    }

    // Fallback: first available variant for that size (keeps user moving)
    const fallback = findFirstAvailableVariantForSize(variants, size);
    if (fallback && fallback.options && fallback.options[2]) {
      setOptionValue(1, fallback.options[0]);
      setOptionValue(2, fallback.options[1]);
      setOptionValue(3, fallback.options[2]);
    }
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', () => {
    ensureValidStativSelection();

    // Re-check whenever options change
    document.addEventListener('change', (e) => {
      const inVariantUI = e.target && e.target.closest && e.target.closest('variant-selects, variant-radios');
      if (!inVariantUI) return;
      // Let theme update variant state first, then correct if needed
      setTimeout(ensureValidStativSelection, 0);
    });
  });
})();
